import { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE } from "@/lib/api";

export const FALLBACK_PLANS = [
  { product: "pro", name: "Pro", price: 19.99, price_yearly: 199, interval: "mo", features: ["Unlimited AI match & cover letters", "Pro AI Studio tools", "Job alerts & daily digest"] },
  { product: "elite", name: "Elite", price: 49.99, price_yearly: 499, interval: "mo", features: ["ATS direct search across 10 boards", "Auto-Apply agent + morning autopilot", "All AI Studio tools & simulations"] },
];

const num = (v) => (typeof v === "number" ? v : Number(String(v ?? "").replace(/[^0-9.]/g, "")) || 0);
const money = (n) => `$${(Math.round(n * 100) / 100).toLocaleString(undefined, { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 })}`;
const monthly = (n) => `$${n.toFixed(2)}`;

export const planId = (p) => p.product || p.id || p.key;
const monthNum = (p) => num(p.price_label || p.price_display || p.price);
export const planPrice = (p) => {
  const v = p.price_label || p.price_display || p.price;
  if (v == null) return "";
  return typeof v === "number" ? monthly(v) : String(v);
};

export const usePublicPlans = () => {
  const [plans, setPlans] = useState(FALLBACK_PLANS);
  useEffect(() => {
    axios.get(`${API_BASE}/billing/plans`)
      .then((r) => { const list = r.data?.plans || r.data; if (Array.isArray(list) && list.length) setPlans(list); })
      .catch(() => {});
  }, []);
  return plans;
};

export const yearlyLive = (p) => p.price_yearly != null || p.yearly_price != null;
const yearNum = (p) => num(p.price_yearly ?? p.yearly_price);
export const savePct = (p) => {
  const m = monthNum(p), y = yearNum(p);
  return m && y ? Math.round(100 * (1 - y / (m * 12))) : 0;
};
export const maxSavePct = (plans = []) => Math.max(0, ...plans.filter(yearlyLive).map(savePct));
export const lowestMonthly = (plans = []) => {
  const v = plans.map(monthNum).filter((n) => n > 0);
  return v.length ? monthly(Math.min(...v)) : "";
};

export const planCost = (p, yearly) => {
  const month = monthNum(p);
  if (!yearly || !month || !yearlyLive(p)) return { price: planPrice(p), unit: p.interval || "mo", note: null };
  const year = yearNum(p);
  const save = month * 12 - year;
  return { price: money(year), unit: "yr", note: `Save ${money(save)}/yr (${savePct(p)}%) · ${money(year / 12)}/mo billed yearly`, save };
};
